<template>
  <div>
    <title>对账统计</title>
    <section class="mainPart">
      <!-- S 统计列表信息组件 -->
      <PaymentReport :accountsflag="0"></PaymentReport>
      <!-- E 统计列表信息组件 -->
    </section>
  </div>
</template>
<script>
export default {
  name:'CollectStatisticsList',
  data () {
    return {
      accountsflag:0, //当前选中菜单
    }
  },
  filters: {

  },
  components: {
    PaymentReport: resolve => require(["@/components/StatisticsFolder/PaymentReport.vue"],resolve), // 收/付款统计列表
  },
  // ============================================== 监听 ==============================================
 watch: {
    
  },
  // ============================================== 方法 ==============================================
  methods: {
  },
  created() {
  },
  mounted () {

  },
  computed: {},
  destroyed(){
  }
}
</script>
<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/DealerStatistics/CollectStatisticsList.vue